import { ChangeDetectorRef } from '@angular/core';
import { EMBED_TYPE_IMAGE_CONTENTS } from 'Angular/constants/core.constants';
import { PARTNER_OPTION_DEFAULT } from 'ChartApp/ts/apps/scatter-plot/constants';
import { SCATTER_PLOT_STATE_KEYS } from 'ChartApp/ts/apps/scatter-plot/state/constants';
import { TECH_CHART_STATE_KEYS } from 'ChartApp/ts/features/tech-chart/constants';
import { SavedItemType } from 'Angular/features/components/saved-items/enums/saved-item-type.enum';
import { FundChartService } from 'ChartApp/ts/services/fund-chart.service';
import { ScatterPlotService } from 'ChartApp/ts/services/scatter-plot.service';
import { TechChartAjaxService } from 'ChartApp/ts/services/tech-chart-ajax.service';
import { formFlattenedObject } from 'Angular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/services/fund-chart.service";
import * as i2 from "ChartApp/ts/services/scatter-plot.service";
import * as i3 from "ChartApp/ts/services/tech-chart-ajax.service";
import * as i4 from "@angular/common";
import * as i5 from "../../../../loaders/loading-symbol/loading-symbol.component";
import * as i6 from "../../../../modals/modal-base/components/modal-base.component";
import * as i7 from "../../../../modals/modal-base/components/simple-modal-header.component";
function OpenItemPreviewModalComponent_ycn_loading_symbol_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 7);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
/**
 * Open Item Preview Modal Component
 *
 * this modal is used for previewing the chart generator image for fund charts, scatter plots and tech charts
 *
 * Input Properties:
 *  savedItemType: string to determine how the imageUrl will be set
 */
export class OpenItemPreviewModalComponent {
    constructor(changeDetectorRef, fundChartService, scatterPlotService, techChartService) {
        this.changeDetectorRef = changeDetectorRef;
        this.fundChartService = fundChartService;
        this.scatterPlotService = scatterPlotService;
        this.techChartService = techChartService;
        this.chartEmbedUrl = '';
        this.header = '';
        this.loading = true;
        this.modalOpen = false;
    }
    closeModal() {
        this.chartEmbedUrl = '';
        this.modalOpen = false;
    }
    openModal(item) {
        this.loading = true;
        this.setChartEmbedUrl(item);
        this.header = `Preview ${item.name}`;
        this.modalOpen = true;
        this.changeDetectorRef.detectChanges();
    }
    setChartEmbedUrl(item) {
        let previewState;
        switch (this.savedItemType) {
            case SavedItemType.FUND_CHART:
                previewState = {
                    ...item.state,
                    legendOnChart: true,
                    chartId: item.id,
                    partner: PARTNER_OPTION_DEFAULT,
                };
                this.chartEmbedUrl = this.fundChartService.getChartEmbedUrl(previewState, EMBED_TYPE_IMAGE_CONTENTS);
                break;
            case SavedItemType.SCATTER_PLOT:
                previewState = {
                    ...formFlattenedObject(item.state, SCATTER_PLOT_STATE_KEYS),
                    chartId: item.id,
                    legendOnChart: true,
                    partner: PARTNER_OPTION_DEFAULT,
                    mode: EMBED_TYPE_IMAGE_CONTENTS,
                };
                this.chartEmbedUrl = this.scatterPlotService.getChartEmbedUrl(previewState);
                break;
            case SavedItemType.TECH_CHART:
                previewState = {
                    ...formFlattenedObject(item.state, TECH_CHART_STATE_KEYS),
                    chartId: item.id,
                    legendOnChart: true,
                    partner: PARTNER_OPTION_DEFAULT,
                };
                this.chartEmbedUrl = this.techChartService.getChartEmbedUrl(previewState, EMBED_TYPE_IMAGE_CONTENTS);
                break;
            default:
        }
    }
    hideLoadingSymbol() {
        this.loading = false;
    }
}
OpenItemPreviewModalComponent.ɵfac = function OpenItemPreviewModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OpenItemPreviewModalComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.FundChartService), i0.ɵɵdirectiveInject(i2.ScatterPlotService), i0.ɵɵdirectiveInject(i3.TechChartAjaxService)); };
OpenItemPreviewModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OpenItemPreviewModalComponent, selectors: [["ycn-open-item-preview-modal"]], inputs: { savedItemType: "savedItemType" }, standalone: false, decls: 7, vars: 7, consts: [[3, "closeModalHandler", "modalBaseClass", "extraModalClasses", "open"], [3, "closeModalHandler", "header", "showUnsavedStatus"], [1, "modal-body"], [1, "modal-section"], [2, "width", "100%", 3, "load", "src"], [3, "loaderMessage", 4, "ngIf"], [1, "modal-footer"], [3, "loaderMessage"]], template: function OpenItemPreviewModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function OpenItemPreviewModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function OpenItemPreviewModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "img", 4);
        i0.ɵɵlistener("load", function OpenItemPreviewModalComponent_Template_img_load_4_listener() { return ctx.hideLoadingSymbol(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, OpenItemPreviewModalComponent_ycn_loading_symbol_5_Template, 1, 1, "ycn-loading-symbol", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(6, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("extraModalClasses", "modal-no-border user-select-none")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.header)("showUnsavedStatus", false);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("src", ctx.chartEmbedUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading);
    } }, dependencies: [i4.NgIf, i5.LoadingSymbolComponent, i6.ModalBaseComponent, i7.SimpleModalHeaderComponent], encapsulation: 2 });
